import styled from 'styled-components';

import { Skeleton } from '@sorare/core/src/atoms/animations/Skeleton';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

const Relative = styled(Vertical)`
  position: relative;
  isolation: isolate;
  align-self: center;
`;
const PlayerScoreSkeleton = styled(Skeleton)`
  height: 24px;
  width: 24px;

  @media ${laptopAndAbove} {
    width: 29px;
    height: 31px;
  }
`;

const AppearanceSkeleton = styled(Skeleton)`
  height: 14px;
  top: calc(100% + var(--half-unit));
  width: var(--quadruple-unit);
  @media ${laptopAndAbove} {
    position: absolute;
  }
`;

const LogoSkeleton = styled(Skeleton)`
  height: 10px;
  top: calc(100% + var(--half-unit));
  width: var(--double-unit);
  @media ${laptopAndAbove} {
    position: absolute;
  }
`;

type Props = {
  variant: 'average-score' | 'projection';
};

export const ScoreSkeleton = ({ variant }: Props) => {
  return (
    <Relative center gap={0.5}>
      <PlayerScoreSkeleton />
      {variant === 'average-score' && <AppearanceSkeleton />}
      {variant === 'projection' && <LogoSkeleton />}
    </Relative>
  );
};
